<template>
  <div class="container">
    <p>{{ t('decarboxylationDescription') }}</p>
    <EquationBlock :equations="equations" />
    <hr />
    <h5>{{ t('thcaLossTitle') }}</h5>
    <div class="row">
      <p>{{ t('thcaLossDescription') }}</p>
      <div class="col-sm">
        <FixedUnitInput
          :input-label="t('productTHCaContent')"
          v-model.number="totalWeight"
          :unit="t('milligrams')"
        />
      </div>
      <div class="col-sm">
        <FixedUnitOutput
          :output-label="t('postDecarbTHCContent')"
          :number="postDecarbWeightOnly"
          :unit="t('mgPerGram')"
        />
      </div>
    </div>
    <hr />
    <h5>{{ t('productBasedLossTitle') }}</h5>
    <div class="row">
      <div class="col-sm">
        <GenericInput
          :input-label="t('productAmount')"
          v-model.number="productWeight"
          :conversionFactors="ConversionFactors.basicWeight"
        />
        <FixedUnitInput
          :input-label="t('productTHCaPercentage')"
          v-model.number="productPotency"
          :unit="t('percent')"
        />
      </div>
      <div class="col-sm">
        <FixedUnitOutput
          :output-label="t('preDecarbTHC')"
          :number="preDecarbTHC"
          :unit="t('milligrams')"
        />
        <FixedUnitOutput
          :output-label="t('postDecarbTHC')"
          :number="postDecarbTHC"
          :unit="t('milligrams')"
        />
      </div>
    </div>
  </div>
</template>

  
  <script>
  import { ref, computed, reactive } from 'vue';
  import { useI18n } from 'vue-i18n';
  import FixedUnitInput from '../inputs/FixedUnitInput.vue';
  import FixedUnitOutput from '../inputs/FixedUnitOutput.vue';
  import GenericInput from '../inputs/GenericInput.vue';
  import EquationBlock from '../inputs/EquationBlock.vue';
  import ConversionFactors from '../../utils/conversion_factors';
  import { defaultRound } from '../../utils/math';
  
  export default {
    components: {
      FixedUnitInput,
      FixedUnitOutput,
      GenericInput,
      EquationBlock
    },
    setup() {
      const totalWeight = ref(25);
      const productWeight = ref(10);
      const productPotency = ref(21);

      const { t, tm } = useI18n();

      // Create a reactive object with a function
      const translations = reactive({
        t: (key) => t(key)
      })

      const equations = computed(() => {
          return tm('decarbLossEquations');
      })
  
      const postDecarbWeightOnly = computed(() => {
        return defaultRound(getPostDecarbWeight(totalWeight.value));
      });
  
      const preDecarbTHC = computed(() => {
        return defaultRound(productWeight.value * productPotency.value * 10);
      });
  
      const postDecarbTHC = computed(() => {
        return defaultRound(getPostDecarbWeight(preDecarbTHC.value));
      });
  
      function getPostDecarbWeight(input) {
        const decarbConstant = 314.45 / 358.4733;
        return input * decarbConstant;
      }
  
      return {
        totalWeight,
        productWeight,
        productPotency,
        postDecarbWeightOnly,
        preDecarbTHC,
        postDecarbTHC,
        ConversionFactors,
        equations,
        t: translations.t
      };
    }
  };
  </script>
  